import { configureStore } from '@reduxjs/toolkit'
import { userSlice } from './user'
import { popupModelDataSlice } from './popupModelData'
import { topEmployeesIdeasSlice } from './topEmployeeIdeas'
import { juryAboutDataSlice } from './juryAbout'
import { ideaModelDataSlice } from './ideaModelData'

export const store = configureStore({
    reducer: {
        user: userSlice.reducer,
        popupModelData: popupModelDataSlice.reducer,
        topEmployeesIdeas: topEmployeesIdeasSlice.reducer,
        juryAbout: juryAboutDataSlice.reducer,
        ideaModelData: ideaModelDataSlice.reducer
    }
})